import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/biscuit.png';
const _withScopeId = n => (_pushScopeId("data-v-4d60f35b"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id", "checked", "disabled", "onUpdate:modelValue"];
const _hoisted_2 = ["for"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "cookie-logo total-center" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: "A delicious cookie"
    })
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Nova has some delicious cookies for you !", -1));
import { reactive, ref } from 'vue';
import cookies from '@/lib/cookies';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CookieLaw',
    setup(__props) {
        const cookieLawIsVisible = cookies.isKey('nova-use-cookies')
            ? ref(false)
            : ref(true);
        const cookiesListIsVisible = ref(false);
        const saveButtonIsVisible = ref(false);
        const cookiesList = reactive([
            {
                name: 'cookies-cookie',
                description: 'Cookies usage authorization cookie',
                isEssential: true,
                isChecked: true,
            },
            {
                name: 'nova-auth-token',
                description: 'Authentication cookie',
                isEssential: true,
                isChecked: true,
            },
            {
                name: 'nova-language',
                description: 'Speech\'s language cookie',
                isEssential: false,
                isChecked: true,
            },
            {
                name: 'nova-theme',
                description: 'Preferred theme cookie',
                isEssential: false,
                isChecked: true,
            },
        ]);
        function closeCookieLaw() {
            cookiesListIsVisible.value = false;
            cookieLawIsVisible.value = false;
        }
        function showCookiesList() {
            cookiesListIsVisible.value = true;
        }
        function hideCookiesList() {
            cookiesListIsVisible.value = false;
            saveButtonIsVisible.value = false;
        }
        function setCookiesPreferences() {
            saveButtonIsVisible.value = true;
            showCookiesList();
        }
        function enablePreferredCookies() {
            cookies.set('nova-use-cookies', cookiesList.filter(cookie => cookie.isChecked).map(cookie => cookie.name));
            closeCookieLaw();
        }
        function enableEssentialCookies() {
            cookies.set('nova-use-cookies', cookiesList.filter(cookie => cookie.isEssential).map(cookie => cookie.name));
            closeCookieLaw();
        }
        function enableAllCookies() {
            cookies.set('nova-use-cookies', cookiesList.map(cookie => cookie.name));
            closeCookieLaw();
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cookie-law", { hidden: !_unref(cookieLawIsVisible) }])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["cookies-list", { hidden: !cookiesListIsVisible.value }])
                }, [
                    _createElementVNode("h4", null, [
                        _createTextVNode(" Cookies used "),
                        _createElementVNode("span", null, [
                            _createVNode(_component_v_icon, {
                                name: "io-close",
                                scale: "1.5",
                                class: "close-cookies-list",
                                onClick: hideCookiesList
                            })
                        ])
                    ]),
                    _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cookiesList, (cookie) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "total-center",
                                key: cookie.name
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    id: cookie.name,
                                    checked: cookie.isChecked,
                                    disabled: cookie.isEssential,
                                    "onUpdate:modelValue": ($event) => ((cookie.isChecked) = $event)
                                }, null, 8, _hoisted_1), [
                                    [_vModelCheckbox, cookie.isChecked]
                                ]),
                                _createElementVNode("label", {
                                    for: cookie.name
                                }, _toDisplayString(cookie.description), 9, _hoisted_2)
                            ]));
                        }), 128))
                    ]),
                    (saveButtonIsVisible.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "save-button total-center",
                            onClick: enablePreferredCookies
                        }, [
                            _createVNode(_component_v_icon, {
                                name: "io-checkmark",
                                scale: "1.5"
                            }),
                            _createTextVNode(" Save Preferences ")
                        ]))
                        : _createCommentVNode("", true)
                ], 2),
                _hoisted_3,
                _createElementVNode("div", { class: "cookie-ask" }, [
                    _createElementVNode("div", { class: "message" }, [
                        _hoisted_4,
                        _createTextVNode(" This website uses cookies to ensure you get the best experience. You can see the list of used cookies "),
                        _createElementVNode("span", { onClick: showCookiesList }, "here"),
                        _createTextVNode(". ")
                    ]),
                    _createElementVNode("div", { class: "buttons-section" }, [
                        _createElementVNode("button", {
                            class: "close total-center",
                            onClick: setCookiesPreferences
                        }, "Set Preferences "),
                        _createElementVNode("button", {
                            class: "decline total-center",
                            onClick: enableEssentialCookies
                        }, "Essentials only "),
                        _createElementVNode("button", {
                            class: "accept total-center",
                            onClick: enableAllCookies
                        }, "Accept All ")
                    ])
                ])
            ], 2));
        };
    }
});
